import styled from "styled-components";

const StyledShopBreadCrumbBundle = styled.button`
  color: ${({theme}) => theme.colors.bundleWhite};
  font-size: 14px;
  outline: none;
  display: flex;
  align-items: center;
  padding: 4px 0;
  margin-right: 1.5rem;
  margin-bottom: .5rem;

  &:hover, 
  &:focus {
      box-shadow: inset 0px -1px 0px 0px #606060;
  }

  :disabled {
    opacity: 0.5;
    cursor: default;
    box-shadow: none;
  }

  svg {
    width: 10px;
    height: 10px;
    fill: #606060;
    margin-right: 6px;
  }
`;
export default StyledShopBreadCrumbBundle;
